export default "__VITE_ASSET__Cd4aclqV__"